/**
 * 公共组件 UploadFile
 */
export default {
  dbl_upload_click: "点击上传",
  dbl_upload_drag: "/拖拽到此区域",
  dbl_upload_info: "支持单个txt和CSV格式，CSV格式内容请勿添加列名",
  dbl_upload_invalid: "文件大小不符合规范，请上传txt文件，大小在60M以内",
  dbl_upload_size: "文件大小：",
  dbl_upload_date: "上传日期：",
  dbl_upload_cancel: "取消上传",
  dbl_upload_reupload: "重新上传",
  dbl_upload_delete: "删除",
  dbl_upload_release_mouse: "释放鼠标"
};